// extracted by mini-css-extract-plugin
module.exports = {"dialogLine":"DialogService_dialogLine_27njH"};